import axios from "axios";

const mainApiURL = process.env.NODE_ENV === "development"
  ? process.env.REACT_APP_BACKEND_API
  : window._CONFIGS.REACT_APP_BACKEND_API;
const secondApiURL = `${mainApiURL}2`;

axios.defaults.baseURL = mainApiURL;
const axiosClient = axios.create();

function setBaseUrl(config) {
  // some logic to determine base URL here
  if (config.AlterBaseURL != null && config.AlterBaseURL != undefined) {
    config.baseURL = secondApiURL;
  }else{
    config.baseURL = mainApiURL;
  }
}

export default {
  client: axiosClient,
  get: axiosClient.get,
  post: axiosClient.post,
  put: axiosClient.put,
  delete: axiosClient.delete,
  head: axiosClient.head,
  patch: axiosClient.patch,
};

// Request interceptor for API calls
axiosClient.interceptors.request.use(function (config) {
  setBaseUrl(config);
  return config;
});
